export const home_page_events = {
  home_zenvoya_logo_click: {
    category: "User clicks on zenvoya logo to navigate to the home page",
    action: "On any page user can click on Zenvoya logo",
    label: "sidebar-logo-click",
  },
  chat_input_field_send_prompt_to_llm_click: {
    category: "User sends search prompt",
    action: "User clicks on prompt send button",
    label: "home-chat-send",
  },
    home_four_trip_suggestions_generated: {
    category: "Home",
    action: "Four trip suggestions generated on home page",
    label: "home-four-trip-suggestions-generated",
  },

  home_chat_input_click: {
    category: "User clicks on input field",
    action: "User clicks on input field to type the prompt",
    label: "home-chat-input",
  },
  home_suggestion_click: {
    category: "Home",
    action: "User clicks a suggestion chip under the latest assistant turn",
    label: "home-suggestion-click",
  },
  chat_input_field_cancel_generating_llm_response: {
    category: "User stops the prompt request",
    action: "User clicks on stop button",
    label: "home-chat-input-stop-click",
  },
  chat_input_field_start_mic_record: {
    category: "User record the prompt by using voice recording",
    action: "User clicks on mic button",
    label: "home-chat-mic-record-click",
  },

  chat_input_field_mic_stop_recording_click: {
    category: "User can stop the voice recording",
    action: "User clicks on mic button to stop recording",
    label: "home-chat-mic-stop-record-click",
  },
  home_chat_voice_start_click: {
    category: "Voice mode",
    action: "User taps the voice button to start voice mode",
    label: "home-chat-voice-start-click",
  },
  home_chat_voice_connected: {
    category: "Voice mode",
    action: "The voice session is live",
    label: "home-chat-voice-connected",
  },
  home_chat_voice_mic_denied: {
    category: "Voice mode",
    action: "The browser blocks the microphone for voice mode",
    label: "home-chat-voice-mic-denied",
  },
  home_chat_voice_start_failed: {
    category: "Voice mode",
    action: "Voice mode fails to connect",
    label: "home-chat-voice-start-failed",
  },
  home_chat_voice_ended: {
    category: "Voice mode",
    action: "Voice mode ends",
    label: "home-chat-voice-ended",
  },
  home_chat_voice_mute_click: {
    category: "Voice mode",
    action: "User mutes the microphone in voice mode",
    label: "home-chat-voice-mute-click",
  },
  home_chat_voice_unmute_click: {
    category: "Voice mode",
    action: "User unmutes the microphone in voice mode",
    label: "home-chat-voice-unmute-click",
  },
  home_chat_voice_request_sent: {
    category: "Voice mode",
    action: "A spoken request or a suggestion chip goes out while voice mode is on",
    label: "home-chat-voice-request-sent",
  },
  home_chat_voice_request_answered: {
    category: "Voice mode",
    action: "A voice request is answered",
    label: "home-chat-voice-request-answered",
  },
  home_chat_voice_request_failed: {
    category: "Voice mode",
    action: "A voice request fails",
    label: "home-chat-voice-request-failed",
  },
  home_chat_voice_request_stopped: {
    category: "Voice mode",
    action: "User stops a voice request",
    label: "home-chat-voice-request-stopped",
  },

  home_tile: {
    category: "Pill prompt",
    action: "User click on one of the pill prompt",
    label: "home-chat-tile",
  },
  home_chat_tile_explore_places: {
    category: "Pill prompt",
    action: "User clicks the 'Explore places' suggestion tile on the welcome screen",
    label: "home-chat-tile-explore-places",
  },
  start_chat: {
    category: "Chat Interaction",
    action: "User interacting with chat",
    label: "start-chat",
  },
  startChat: {
    category: "Chat Interaction",
    action: "User interacting with chat",
    label: "startChat",
  },
  appLoaded: {
    category: "Application Loaded",
    action: "When the application is loaded",
    label: "appLoaded",
  },
  signUp: {
    category: "User Sign Up",
    action: "When the user signs up",
    label: "signUp",
  },
  interactedWithChat: {
    category: "User Interaction with Chat",
    action: "User interacted with chat on home page",
    label: "interactedWithChat",
  },
  onboarding_itinerary_creation_auto: {
    category: "Onboarding Itinerary Creation",
    action: "Automatic itinerary creation during onboarding",
    label: "onboarding_itinerary_creation_auto",
  },
   home_chat_try_again_click: {
    category: "Chat Interuption",
    action: "User clicked on home chat try again",
    label: "home-chat-try-again-click",
  },
  home_chat_scroll_down_click: {
    category: "Home",
    action: "User taps the scroll-down button in the chat",
    label: "home-chat-scroll-down-click",
  },
};
